import React, { useState } from "react";
import "./style.css";
import axios from "axios";

const ImportData = () => {
  const [isModalOpen, setIsModalOpen] = useState(false);
  const [file, setFile] = useState<File | null>(null);
  const [error, setError] = useState<string | null>(null);
  const [isLoading, setIsLoading] = useState(false);

  const doiman = process.env.REACT_APP_API_URL;
  const token = localStorage.getItem("accessToken");

  const handleImport = async () => {
    if (!file) {
      setError("Vui lòng chọn file để import");
      return;
    }

    setIsLoading(true);
    const formData = new FormData();
    formData.append("file", file);

    try {
      const response = await axios.post(
        `${doiman}/olympic_uet/upload`,
        formData,
        {
          headers: {
            Authorization: `Bearer ${token}`,
            "Content-Type": "multipart/form-data",
          },
          responseType: "arraybuffer", // Thay đổi responseType thành arraybuffer
        }
      );

      // Chuyển đổi arraybuffer thành string để kiểm tra response
      const decoder = new TextDecoder("utf-8");
      try {
        const jsonString = decoder.decode(response.data);
        const result = JSON.parse(jsonString);

        if (result.message === "OK") {
          alert(result.data);
          resetForm();
          return;
        }
      } catch (e) {
        // Nếu không parse được JSON, có nghĩa đây là file Excel
        console.log("Response is an Excel file");
      }

      // Xử lý download file Excel
      const blob = new Blob([response.data], {
        type: "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet",
      });

      alert(
        "Có một số lỗi xảy ra khi import dữ liệu. Nhấn OK để tải file lỗi về."
      );

      // Download file
      downloadExcelFile(blob);
      resetForm();
    } catch (error: any) {
      console.error("Error:", error);
      setError("Có lỗi xảy ra khi import dữ liệu.");
    } finally {
      setIsLoading(false);
    }
  };

  const downloadExcelFile = (blob: Blob) => {
    const url = window.URL.createObjectURL(blob);
    const link = document.createElement("a");
    link.href = url;
    link.setAttribute("download", "Thong_tin_chi_tiet.xlsx");
    document.body.appendChild(link);
    link.click();

    // Cleanup
    document.body.removeChild(link);
    window.URL.revokeObjectURL(url);
  };

  const resetForm = () => {
    setFile(null);
    const fileInput = document.getElementById("file-input") as HTMLInputElement;
    if (fileInput) fileInput.value = "";
    setIsModalOpen(false);
  };

  const handleFileChange = (event: React.ChangeEvent<HTMLInputElement>) => {
    const selectedFile = event.target.files?.[0];
    if (selectedFile) {
      if (!selectedFile.name.endsWith(".xlsx")) {
        setError("Chỉ chấp nhận file Excel (.xlsx)");
        event.target.value = "";
        return;
      }
      setFile(selectedFile);
      setError(null);
    }
  };

  return (
    <div>
      <button onClick={() => setIsModalOpen(true)}>Import dữ liệu</button>

      {isModalOpen && (
        <div className="modal-header">
          <div className="modal-content">
            <div className="modal-header-content">
              <h2>Import File</h2>
              <button onClick={() => setIsModalOpen(false)}>X</button>
            </div>

            <div className="modal-body">
              {error && <div className="error-message">{error}</div>}

              <h3>File Upload</h3>
              <input
                id="file-input"
                type="file"
                accept=".xlsx"
                onChange={handleFileChange}
                style={{ padding: 10 }}
              />

              <br />
              <a href="/template_mau_import_olympic.xlsx" download>
                Tải file mẫu tại đây
              </a>

              <div className="modal-footer">
                <button
                  onClick={() => setIsModalOpen(false)}
                  className="cancel-button"
                  disabled={isLoading}
                >
                  Hủy
                </button>
                <button
                  onClick={handleImport}
                  className="upload-button"
                  disabled={!file || isLoading}
                >
                  {isLoading ? "Đang xử lý..." : "Upload"}
                </button>
              </div>
            </div>
          </div>
        </div>
      )}
    </div>
  );
};

export default ImportData;
